"use client";

import { useEffect, useState } from "react";
import Lottie from "react-lottie";

interface LottieWrapperProps {
  options: any;
  width?: number;
  height?: number;
  className?: string;
}

export function LottieWrapper({
  options,
  width,
  height,
  className,
}: LottieWrapperProps) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return (
      <div
        className={className}
        style={{ width, height }}
        suppressHydrationWarning
      />
    );
  }

  return (
    <div suppressHydrationWarning>
      <Lottie options={options} width={width} height={height} />
    </div>
  );
}
